import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "price" };
const _hoisted_2 = {
    key: 0,
    class: "price__currency"
};
const _hoisted_3 = { class: "price__amount" };
const _hoisted_4 = {
    key: 1,
    class: "price__original"
};
const _hoisted_5 = {
    key: 2,
    class: "price__unit"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'Price',
    props: {
        currency: {},
        amount: {},
        original: {},
        unit: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                (__props.currency)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.currency), 1))
                    : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("span", _hoisted_3, _toDisplayString(__props.amount), 1),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (__props.original)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.original), 1))
                    : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (__props.unit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "\n            / " + _toDisplayString(__props.unit), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
